import type { AsyncState } from '../../../platform/async/Async'
import type { Cashflow } from '../../cashflow/cashflowWire'

export const WHERE_ROWS = 4

export type WhereRow = { categoryId: string; name: string; amountCents: number; sharePct: number }

export type WhereView = {
  currency: string
  /** The top four of the server's own order. There is no "Other" row: an Other row is a sum. */
  rows: WhereRow[]
  /** A count of the server's categories. */
  categoryCount: number
}

/**
 * The period call's category breakdown as the widget's state. Amounts and
 * shares are the server's, names come from the categories list (a dash until it resolves, as Recent does). Used only for
 * an entitled user — a free user's call carries no breakdown and the widget
 * shows the locked preview instead.
 */
export function toWhereState(period: AsyncState<Cashflow>, names: ReadonlyMap<string, string>): AsyncState<WhereView> {
  if (period.status !== 'success' && period.status !== 'stale') return period
  const breakdown = period.data.breakdown
  // The entitlement flipped and the call that carries the breakdown has not answered yet.
  if (breakdown === null) return { status: 'loading' }
  const all = breakdown.categories
  if (all.length === 0) return { status: 'empty' }
  return {
    status: 'success',
    data: {
      currency: period.data.currency,
      rows: all.slice(0, WHERE_ROWS).map((c) => ({
        categoryId: c.categoryId,
        name: names.get(c.categoryId) ?? '—',
        amountCents: c.amountCents,
        sharePct: c.sharePct,
      })),
      categoryCount: all.length,
    },
  }
}
